var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_5010)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.6566,
    y: 36.1875,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.1566,
    y: 36.6875,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.271 78.6431H143.861L113.143 169.711C112.986 170.177 112.757 170.614 112.466 171.009C112.174 171.404 111.823 171.75 111.424 172.037C111.026 172.323 110.585 172.545 110.118 172.695C109.65 172.845 109.163 172.923 108.673 172.923H85.6438C84.8963 172.923 84.1587 172.745 83.4937 172.403C82.8279 172.061 82.2533 171.566 81.8173 170.958C81.3811 170.35 81.0958 169.647 80.9848 168.906C80.8735 168.166 80.941 167.41 81.1798 166.701L109.799 81.8521C109.955 81.3871 110.184 80.9495 110.477 80.5545C110.768 80.1595 111.121 79.8132 111.518 79.5269C111.917 79.2407 112.357 79.0181 112.824 78.8681C113.292 78.7181 113.779 78.6406 114.269 78.6406V78.6419L114.271 78.6431Z",
    fill: "url(#paint0_linear_936_5010)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M168.819 172.923H142.249C141.952 172.923 141.656 172.896 141.364 172.84C141.072 172.785 140.786 172.702 140.51 172.593C140.234 172.485 139.969 172.35 139.717 172.192C139.466 172.034 139.231 171.852 139.014 171.65L108.862 143.49C108.543 143.192 108.321 142.806 108.224 142.38C108.128 141.955 108.162 141.51 108.321 141.104C108.481 140.698 108.76 140.349 109.12 140.104C109.482 139.859 109.908 139.728 110.344 139.728H157.267L168.817 172.925L168.819 172.923Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.968 78.6426L123.254 139.733L157.098 139.725L168.708 172.923H142.237C141.964 172.92 141.69 172.895 141.42 172.846C141.15 172.798 140.885 172.726 140.627 172.631C140.111 172.443 139.631 172.168 139.207 171.818L118.853 152.821L113.156 169.625C113.008 170.045 112.806 170.444 112.553 170.81C112.047 171.547 111.355 172.136 110.547 172.519C110.144 172.709 109.719 172.845 109.28 172.923H85.6575C84.9025 172.925 84.1574 172.745 83.4861 172.398C82.8147 172.05 82.2368 171.547 81.8012 170.929C81.3656 170.311 81.0851 169.598 80.9835 168.849C80.8822 168.099 80.9624 167.337 81.2172 166.625L109.79 81.9154C109.939 81.4416 110.163 80.9953 110.453 80.5928C110.742 80.1902 111.094 79.8352 111.494 79.5427C111.894 79.2502 112.339 79.0227 112.811 78.8702C113.282 78.7176 113.776 78.6401 114.272 78.6426H143.969H143.968Z",
    fill: "url(#paint1_linear_936_5010)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.685 166.702C180.924 167.411 180.991 168.167 180.881 168.907C180.77 169.647 180.485 170.35 180.05 170.958C179.614 171.566 179.039 172.061 178.374 172.403C177.709 172.745 176.971 172.923 176.223 172.924H143.244C143.991 172.924 144.729 172.745 145.395 172.404C146.06 172.062 146.635 171.566 147.072 170.958C147.508 170.351 147.793 169.647 147.904 168.907C148.015 168.167 147.948 167.411 147.709 166.702L119.088 81.85C118.773 80.9153 118.173 80.103 117.372 79.5274C116.975 79.2411 116.534 79.0198 116.068 78.8698C115.602 78.7198 115.114 78.6436 114.626 78.6436H147.604C148.094 78.6436 148.58 78.7198 149.048 78.8698C149.514 79.0198 149.954 79.2423 150.353 79.5274C150.751 79.8136 151.102 80.1599 151.393 80.5537C151.684 80.9475 151.912 81.385 152.069 81.85L180.69 166.702H180.685Z",
    fill: "url(#paint2_linear_936_5010)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_5010",
    x: 0.656616,
    y: 0.1875,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_5010"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_5010",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_936_5010",
    x1: 125.07,
    y1: 85.6311,
    x2: 94.3183,
    y2: 176.474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_936_5010",
    x1: 134.658,
    y1: 127.958,
    x2: 127.545,
    y2: 130.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_936_5010",
    x1: 130.733,
    y1: 82.9813,
    x2: 164.485,
    y2: 172.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.beaaa2d6b856450a1ca710f697421d46.svg";
export { ForwardRef as ReactComponent };